import dayjs from "dayjs";
import { useCallback } from "react";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import ScrollableTable from "src/components/shared/ScrollableTable/ScrollableTable";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";
import { getYachtId } from "src/utils";

import ReviewCommentsRow from "./ReviewCommentsRow";

export interface IRequest {
  aid: string;
  requestedBy: string;
  yacht: string;
  requestDate: string;
  status: { label: string; color: string };
}

const headers = [
  { label: "Requested By" },
  { label: "Yacht" },
  { label: "Request Date" },
  { label: "Status", style: { width: 200 } },
  { label: "", style: { width: 300 } },
];

const statuses = {
  1: { label: "Pending", color: "" },
  2: { label: "Approved", color: "#1864ab" },
  3: { label: "Denied", color: "red" },
};

const mapRequests = (data: any) =>
  data.list.map((req: any) => ({
    aid: req.id,
    requestedBy: req.full_name,
    yacht: req.yachtname,
    requestDate: dayjs(req.reqdate).format("D MMM YYYY - HH:mm"),
    status: statuses[req.reqstatus as keyof typeof statuses],
  }));

const ReviewComments = () => {
  const { data, refetch } = useGetApi<IRequest[]>({
    request: "get-req-comments",
    body: { params: { yachtid: getYachtId() } },
    mapper: mapRequests,
  });

  const renderRow = useCallback(
    ({ row }: { row: IRequest }) => (
      <ReviewCommentsRow request={row} refetch={refetch} />
    ),
    [refetch],
  );

  return (
    <PageContainer>
      <Breadcrumbs border={false} />
      <ScrollableTable
        data={data ?? []}
        headers={headers}
        renderRow={renderRow}
        keyExtractor={row => row.aid}
      />
    </PageContainer>
  );
};

export default ReviewComments;
